module.exports = ".ui-calendar.ui-calendar-w-btn input {  width:96%!important;}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/user/reset-password/reset-password.component.css
// module id = ./src/app/user/reset-password/reset-password.component.css
// module chunks = main